import React, {useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import {Group, Item} from '@pb/kit-component-group';
import {PaginationStripe} from '@pb/kit-component-pagination';

import {ContractListHeader} from '../../contracts/components/contract-list-header';
import {crmIntegrationSelector} from '../../setup/services/selectors';

import {ContractItem} from './contract-item';

import type {ContractsListDto, OnUpdateContractInfo, OnUpdateCredits} from '../typedef';
import type {Pagination} from 'src/openapi/admin/models/Pagination';


type Props = {
    data: ContractsListDto,
    allContractNumbers: Array<string>,
    isPastContract?: boolean,
    lastCreatedNumber: string | null,
    onUpdateContractInfo: OnUpdateContractInfo,
    onUpdateCredits: OnUpdateCredits,
    disabled?: boolean,
};

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

export const ContractsList = ({data, isPastContract, disabled, ...rest}: Props) => {
    const [currentPage, setCurrentPage] = useState<number>(DEFAULT_PAGE);
    const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
    const crmIntegration = useSelector(crmIntegrationSelector);

    const onPaginationChange = useCallback((changedPagination: Pagination) => {
        setCurrentPage(changedPagination.currentPage);
        setPageSize(changedPagination.pageSize);
    }, []);

    useEffect(() => {
        setCurrentPage(DEFAULT_PAGE);
    }, [data]);

    const startIndex = pageSize * (currentPage - 1);
    const endIndex = startIndex + pageSize;
    const pageData = data.slice(startIndex, endIndex);
    const creditsDataAvailable = !crmIntegration;

    return (
        <Group direction="v" gap="s">
            <Item>
                <ContractListHeader {...{isPastContract, creditsDataAvailable}}/>
                {pageData.map(item => (
                    <ContractItem
                        key={item.contractInfo.contractId}
                        {...{
                            data: item,
                            creditsDataAvailable,
                            isPastContract: isPastContract || null,
                            disabled,
                            ...rest,
                        }}
                    />
                ))}
            </Item>
            <PaginationStripe
                totalCount={data.length}
                currentPage={currentPage}
                pageSize={pageSize}
                onPaginationChange={onPaginationChange}
            />
        </Group>
    );
};
